import certageLandingLogo from "./images/certage_landing_logo.png";
import certageLogo from "./images/certage-logo.svg";
import certageError from "./images/certage_error.svg";
import cameraBlockedError from "./images/camera_blocked_error.svg";
import certageCheckmar from "./images/certage_checkmar.svg";
import spinner from "./images/Spinner@1x-1.0s-200px-200px.svg";
import weuiBackFilled from "./images/weui_back-filled.svg";

export const images = {
  certageLandingLogo,
  certageLogo,
  certageError,
  cameraBlockedError,
  certageCheckmar,
  spinner,
  weuiBackFilled,
};
